import { render, staticRenderFns } from "./additional-inputs.vue?vue&type=template&id=6a5cf208&scoped=true&lang=pug"
import script from "./additional-inputs.vue?vue&type=script&lang=js"
export * from "./additional-inputs.vue?vue&type=script&lang=js"
import style0 from "./additional-inputs.vue?vue&type=style&index=0&id=6a5cf208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5cf208",
  null
  
)

export default component.exports